import { createSlice } from "@reduxjs/toolkit";
import { listPackageBenefits, deletePackageBenefit } from "../Action/PackageBenefits";

const PackageBenefitsSlice = createSlice({
  name: "PackageBenefits",
  initialState: {
    benefitsArr: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(listPackageBenefits.fulfilled, (state, action) => {
      state.benefitsArr = action.payload || [];
    });
    builder.addCase(deletePackageBenefit.fulfilled, (state, action) => {
      const id = action.payload?.id;
      if (!id) return;
      state.benefitsArr = state.benefitsArr.filter((b) => b._id !== id);
    });
  }
});

export default PackageBenefitsSlice.reducer;
